import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'

const DetailCommuterModal = (props) => {
    const { show, handleClose, data } = props
    

    return (
        <>
            <Modal
                size="lg"
                show={show}
                onHide={() => handleClose()}
                aria-labelledby="example-modal-sizes-title-lg"
                centered
            >
                <Modal.Header className='px-0'>
                    <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                        Commuter Detail
                    </Modal.Title>
                    <button className="modal-close-btn me-4 text-center" onClick={handleClose}>
                        <ImCross color='#fff' size={12} />
                    </button>
                </Modal.Header>
                <Modal.Body className='px-4 justify-content-center'>
                    <Row>
                        <Col md={4}>
                            <div className='modal-small-heading'>Name</div>
                            <div className="modal-detail-value">{data?.name}</div>
                        </Col>

                        <Col md={4}>
                            <div className='modal-small-heading'>Email</div>
                            <div className="modal-detail-value">{data?.email}</div>
                        </Col>


                        <Col md={4}>
                            <div className='modal-small-heading'>Phone Number</div>
                            <div className="modal-detail-value">{data?.phone_no}</div>
                        </Col>
                    </Row>

                    <Row className='mt-5'>
                        <Col md={4}>
                            <div className='modal-small-heading'>Gender</div>
                            <div className="modal-detail-value">{data?.gender}</div>
                        </Col>

                        <Col md={4}>
                            <div className='modal-small-heading'>DOB</div>
                            <div className="modal-detail-value">{data?.dob}</div>
                        </Col>


                        <Col md={4}>
                            <div className='modal-small-heading'>No of Trips</div>
                            <div className="modal-detail-value">{data?.no_of_trips}</div>
                        </Col>
                    </Row>

                    <Row className='my-5'>
                        <Col md={4}>
                            <div className='modal-small-heading'>Total Distance Traveled</div>
                            <div className="modal-detail-value">Not added yet</div>
                        </Col>

                        <Col md={4}>
                            <div className='modal-small-heading'>GHG Emission Saved</div>
                            <div className="modal-detail-value">Not added yet</div>
                        </Col>


                        <Col md={4}>
                            <div className='modal-small-heading'>Earned Points</div>
                            <div className="modal-detail-value">{data?.reward_points}</div>
                        </Col>
                    </Row>


                </Modal.Body>
            </Modal>
        </>
    )
}

export default DetailCommuterModal